import React, { useContext } from "react";
import styles from "../bussiness.module.css";
import { AiFillDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import ReactTooltip from "react-tooltip";
// import CustomerClubContext from "./../../context/CustomerClubContext";

const BoxScore = ({ item, customers, setSelectedItem }) => {
  // const { setEditScoreItem } = useContext(CustomerClubContext);
  const editHandler = () => {
    setSelectedItem(item);
    // setEditScoreItem(item);
  };

  return (
    <div
      className={`  w-100  ${styles.sec}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            کاربر
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.name}{" "}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            امتیاز
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.price}{" "}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            موبایل
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.mobile}
          </div>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            زمان ثبت
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.submitTime}
          </p>
        </div>
        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تاریخ انجام
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.date}
          </p>
        </div>

        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center  ${styles.blueRow}`}
          >
            نوع
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.price}
          </p>
        </div>

        <div className={`${styles.BlueCol} ${styles.club}`}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalDeleteScore`}
              onClick={editHandler}
            >
              <h4 data-tip="حذف">
                <AiFillDelete className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModalEditScore`}
              onClick={editHandler}
            >
              <h4 data-tip="ویرایش">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoxScore;
